<div>
    <div>
        <div class="row pt-0">
            <div class="col-lg-12">
                <div class="clearfix">            
                    <ul class="nav nav-tabs custom top">
                        
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#ta"><strong>Incident Reports</strong></a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link " data-toggle="tab" href="#tb"><strong>Traffic Tickets</strong></a>
                        </li>
                                         
                    </ul>
                </div>
                <div class="tab-content top">
                        <div class="tab-pane active" id="ta">
                                <div class="row pt-0">
                                    <div class="col-md-12">
<!--                                         <signature-pad style="display: none;" [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()"></signature-pad>
 -->                                        
                            <signature-pad style="display: none;" [options]="signaturePadOptions" (onBeginEvent)="drawStart()"></signature-pad>
                                        
                                        <div class="btn-group">
                                            <button type="button" class="btn btn-secondary btn-sm mb-1 mr-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" placement="bottom"
                                                ngbTooltip="Add">
                                                <span class="sr-only">Add</span><i class="fa fa-lg fa-plus"></i>
                                            </button>
                                            <div class="dropdown-menu">
                                                <a (click)="openIncidentModal(null)" class="dropdown-item" href="javascript:void(0);">Add & Upload Incident Report</a> 
                                                <a (click)="openIncidentModalMobile(null)" class="dropdown-item" href="javascript:void(0);">Add & Generate Incident Report</a> 
                                            </div>
                                        </div>
                                            
                                        <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1"
                                        (click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
                                       <i class="fa fa-lg fa-filter"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Filter</span>
                                        </button>
                                                
                                        <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="print('incident-print-section')" placement="bottom" [disabled]="incidentCount < 1"
                                        ngbTooltip="Print List">
                                        <i class="fa fa-lg fa-print"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Print</span>
                                        </button>

                                        <div class="btn-group mr-1">
                                            <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="incidentCount < 1"
                                                placement="bottom" ngbTooltip="Export List">
                                                <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Export</span>
                                            </button>
                                            <div class="dropdown-menu fs-12">
                                                <a (click)="incidentRep_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                                                <a (click)="incidentRep_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
                                                <a (click)="incidentRep_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                                            </div>
                                        </div>
                                        
                                        <div class="btn-group mb-1">
                                            <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                                placement="bottom" ngbTooltip="Show/Hide Columns">
                                                <span class="sr-only">Toggle Dropdown</span>
                                            <i class="fa fa-lg fa-check-square-o"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Columns</span>
                                            </button>
                                            <div class="dropdown-menu fs-12" style="width: 150px;">
                                                <div class="col-md-12 mb-3 fs-12">
                                                    <input type="checkbox" [(ngModel)]="showIncidentDate" >&nbsp;Date<br />
                                                    <input type="checkbox" [(ngModel)]="showIncidentTime">&nbsp;Time<br />
                                                    <input type="checkbox" [(ngModel)]="showIncidentDriver">&nbsp;Driver<br />
                                                    <input type="checkbox" [(ngModel)]="showIncidentStatus">&nbsp;Status<br />
                                                    <input type="checkbox" [(ngModel)]="showIncidentFile">&nbsp;File<br />
                                                </div>
                                            </div>
                                        </div>

                                    <span *ngIf="myDropDown=='range'" class="pull-right" >&nbsp;
                                        <input type="text"   width="120" class="mb-1" class="dateRangeInput" matInput
                                        ngxDaterangepickerMd
                                        [locale]="locale"
                                        startKey="start"
                                        endKey="end"
                                        [showWeekNumbers]="true"
                                        [showDropdowns]="true"
                                        [(ngModel)]="incidentDateRange"
                                        (ngModelChange)="processIncidentDateRange($event)"
                                        name="daterange" 
                                        [autoApply]="true"
                                        opens="left"
                                        drops="down"
                                        [maxDate]="maxDate"
                                        />
                                    </span>
                        
                                    <select [(ngModel)]="myDropDown" (ngModelChange)="onChangeofOptions($event)" class="dateFilter  btn btn-sm  btn-secondary mb-1 pull-right">
                                                <option value="today">Today</option>
                                                <option value="week">This Week</option>
                                                <option value="month">This Month</option>
                                                <option value="years">This Year</option>
                                                <option value="7">Last 7 days</option>
                                                <option value="14">Last 14 days</option>
                                                <option value="30">Last 30 days</option>
                                                <option value="90">Last 90 days</option>
                                                <option value="range">Custom date range</option>
                                        </select>


                                    </div>
                                </div>
                                <br *ngIf="showFilters" />
                                <div class="row pt-0">
                                    <div class="col-md-12">
                                        <div widget class="card border-0 box-shadow" *ngIf="showFilters">
                                            <div class="card-header border-0 text-muted">
                                                <h5 class="mb-0">Search Incident Reports:</h5>
                                                <div class="widget-controls"> 
                                                    <a data-widgster="close"class="transition" (click)="toggleFilters()"><i class="fa fa-times"></i></a>
                                                </div>  
                                            </div>
                                            <div class="card-body card-header pt-0 widget-body">
                                                <div class="row pt-0">
                                                    <div class="form-group col-md-6" *ngIf="!driver_id">
                                                        <label>Driver:</label><br> 
                                                        <select placeholder="Select" [(ngModel)]="filterIncidentDriver" (change)="updateFilter(prefixIncident)"> 
                                                            <option selected disabled>Select..</option>
                                                            <option *ngFor="let dr of drivers" value="{{dr.id}}">{{dr.full_name}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="form-group col-md-6">
                                                        <label>Type:</label><br>
                                                        <select placeholder="Select" [(ngModel)]="filterIncidentType" (change)="updateFilter(prefixIncident)"> 
                                                            <option selected disabled>Select..</option>
                                                            <option *ngFor="let ty of incident_types" value="{{ty.id}}">{{ty.name}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="row" *ngIf="!isFilterEmpty || incidentDateRange !=''">
                                                    <div class="col-md-12">
                                                        <button  type="button" class="btn btn-success btn-sm mb-1" (click)="resetFilters(prefixIncident)">
                                                                <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-lg fa-filter"></i></span>
                                                                <span> Reset Filters</span>
                                                        </button> &nbsp;
                                                    </div>
                                                </div>                                  
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br *ngIf="showFilters" />
                                <ngx-loading [show]="loading_indicator2"></ngx-loading>
                                <div class="row pt-0" *ngIf=" !loading_indicator2" >
                                    <div class="col-md-8">
                                        
                                        <div class="card-body pt-0 pl-0 widget-body">
                                            <span  class="card-body">
                                                <span class="badge badge-pill badge-completed pull-right">Resolved</span>
                                                <span class="badge badge-pill badge-pending pull-right">Pending</span>
                                            </span><br />
                                            <ngx-datatable
                                                [loadingIndicator]="loading_indicator2"
                                                class="material table table-hover"
                                                [rows]="incident_rows"
                                                [columnMode]="'force'"
                                                [columns]="incident_columns"
                                                [footerHeight]="40"
                                                [rowHeight]="'auto'"
                                                [limit]="20"
                                                [selected]="selected2"
                                                [selectionType]="'single'"
                                                (activate)="onActivate2($event)"
                                                (select)='onSelect2($event)'
                                                [scrollbarH]="true"
                                                >
        
                                                <ngx-datatable-column prop="id" name="Operations" headerClass="header" [width]="130" [cellClass]="getCellClass"> 
                                                    <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                                                        <div align="left" style="padding-right:20px">  
                                                            <a title="Edit" (click)="openIncidentModal(row)"><i class="fa fa-lg fa-edit"></i></a>&nbsp;
                                                            <a title="Delete" (click)="openDeleteIncidentModal(row)"><i class="fa fa-lg fa-trash"></i></a>&nbsp;
                                                            <a title="Create New Task" (click)="openPromptModalTask(modalTaskForm, null, row.id, prefixIncident)"><i class="fa fa-lg fa-plus-square-o"></i></a>&nbsp;
                                                            <a *ngIf="row.incidentTaskCount > 0" title="Mark as Completed" (click)="openMarkCompleteModal(modalMarkCompleted,prefixIncident)"><i class="fa fa-lg fa-check-square-o"></i></a>
        
                                                        </div>
                                                    </ng-template>     
                                                </ngx-datatable-column>
                                                <ngx-datatable-column name="Date" prop="date_added"  headerClass="header" [width]="120" *ngIf="showIncidentDate" [cellClass]="getCellClass">
                                                        <ng-template let-value="value" ngx-datatable-cell-template>
                                                            {{ (formatDate(value) !== null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                                                        </ng-template>
                                                </ngx-datatable-column>
                                                <ngx-datatable-column name="Time" prop="time_added"  headerClass="header" [width]="120" *ngIf="showIncidentTime" [cellClass]="getCellClass">
                                                        <ng-template let-value="value" ngx-datatable-cell-template>
                                                            {{ (value !== null) ? ('1999-01-01 ' + value | date: 'h:mm a') : "No Record"  }}
                                                        </ng-template>                        
                                                    </ngx-datatable-column>
                                                <ngx-datatable-column name="Driver" prop="driver"  headerClass="header" [width]="180" *ngIf="showIncidentDriver" [cellClass]="getCellClass">
                                                </ngx-datatable-column>
        
                                                <ngx-datatable-column name="Status" prop="status"  headerClass="header" [width]="120"  *ngIf="showIncidentStatus" [cellClass]="getCellClass"></ngx-datatable-column> 
        
                                                <ngx-datatable-column name="File" prop="filename"  headerClass="header" [width]="215" *ngIf="showIncidentFile" [cellClass]="getCellClass">
                                                    <ng-template let-value="value" ngx-datatable-cell-template>
                                                        <a class="incident_hover" href="{{fileStoragePath}}/incident/{{value}}" target="_new">{{value}}</a>
                                                    </ng-template>
                                                </ngx-datatable-column>
                                            </ngx-datatable>
        
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div widget class="card border-0 box-shadow selected-column">
                                                <div class="card-header transparent border-0 text-muted">
                                                    <h5 class="mb-0">Details:</h5>
                                                    <div class="widget-controls"></div>        
                                                </div>
                                                <div class="card-body pt-0 widget-body">
                                                    <ul>
                                                        <div *ngFor='let sel2 of selected2'>
                                                            <label class="titleHeader"><b>{{sel2["driver"]}}</b></label>&nbsp;&nbsp;<a *ngIf="sel2['filename']!==null && sel2['filename']!==''" href="{{fileStoragePath}}/incident/{{sel2['filename']}}" target="_new" title="View File"><i class="fa fa-file"></i></a> &nbsp;
                                                          
                                                            <tr>
                                                                <td><b>Datetime: </b></td>
                                                                <td class="col-md-8">{{sel2.date_added}} - {{sel2.time_added}} <br /></td>
                                                            </tr>
                                                             
                                                            <tr>
                                                                <td><b>Location: </b></td>
                                                                <td class="col-md-8"> {{sel2.location}}</td>
                                                            </tr>
                                                          
                                                            <tr>
                                                                <td><b>Type: </b></td>
                                                                <td class="col-md-8">{{sel2.type}}</td>
                                                            </tr>

                                                            <tr>
                                                                <td><b>Rego: </b></td>
                                                                <td class="col-md-8">{{sel2.rego}}</td>
                                                            </tr>

                                                            <tr>
                                                                <td><b>Status: </b></td>
                                                                <td class="col-md-8"> 
                                                                    <span *ngIf="sel2.status_id == 2" class="badge badge-pill badge-completed">Resolved</span>
                                                                    <span *ngIf="sel2.status_id == 1" class="badge badge-pill badge-pending">Pending</span><br>
                                                                </td>
                                                            </tr>
                                                       
                                                            <tr>
                                                                <td><b>Description: </b></td>
                                                                <td class="col-md-8">{{sel2.description}}</td>
                                                            </tr>

                                                            <tr>
                                                                <td><b>Notification: </b></td>
                                                                <td class="col-md-8"> {{sel2.notification}}</td>
                                                            </tr>

                                                            <tr>
                                                                <td><b>Witness: </b></td>
                                                                <td class="col-md-8">{{sel2.witness}}</td>
                                                            </tr>

                                                            <tr>
                                                                <td><b>Rating: </b></td>
                                                                <td class="col-md-8">
                                                                    <span *ngFor="let st of ratings">
                                                                        <span *ngIf="st.id == sel2.rating_id"> {{st.name}}</span>
                                                                    </span><br/>
                                                                </td>
                                                            </tr>
                                                            <br>
                                                            <button type="button" class="btn btn-sm btn-secondary mb-1" (click)="openIncidentModal(sel2)">
                                                                <span class="badge badge-pill badge-white text-primary ml-1"></span>
                                                               Edit
                                                            </button>&nbsp;
                                                            <button type="button" class="btn btn-sm btn-danger mb-1" (click)="openDeleteIncidentModal(sel2)">
                                                                <span class="badge badge-pill badge-white text-primary ml-1"></span>
                                                                Delete
                                                            </button>

                                                        </div>
                                                        <div *ngIf="!selected2.length" class="text-center"> 
                                                            <p> Select an item to display details. </p>
                                                        </div>
                                                    </ul>                              
                                                </div>
                                        </div>
                                        <br />
                                        <div widget class="card border-0 box-shadow selected-column">
                                                <div class="card-header transparent border-0 text-muted">
                                                    <h5 class="mb-0">Incident Tasks:</h5>
                                                    <div class="widget-controls">
                                                    </div>        
                                                </div>
                                                <div class="card-body pt-0 widget-body">
                                                    <div *ngFor='let sel2 of selected2'>
                                                        
                                                        <div *ngIf ="sel2.incidentTaskCount > 0">
                                                            <button type="button" class="btn btn-sm btn-secondary mb-1" (click)="openMarkCompleteModal(modalMarkCompleted, prefixIncident)">
                                                            <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-check-square-o"></i></span>
                                                            Mark as Completed
                                                            </button>
                                                            <br />
                                                            <table class="table table-sm">
                                                                <thead>
                                                                    <tr>
                                                                        <th></th>
                                                                        <th><small><strong>Title</strong></small></th>
                                                                        <th><small><strong>Assigned To</strong></small></th>
                                                                        <th><small><strong>% Done</strong></small></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr *ngFor="let task of tasksByIncidentId | paginate: { itemsPerPage: 5, currentPage: ip }">
                                                                        <td><small><i class="fa fa-pencil" title="Edit Task" (click)="openPromptModalTask(modalTaskForm, task, sel2.id, prefixIncident)"></i> <i *ngIf="task.status_name !== 'Completed' && task.status_name !== 'Cancelled'" class="fa fa-check" title="Mark Task Completed" (click)="openPromptModal(modalMarkTaskCompleted,task, prefixIncident)"></i>
                                                                            <i class="fa fa-trash" title="Delete Task" (click)="openPromptModal(modalDeleteTask,task, prefixIncident)"></i></small>
                                                                        </td>
                                                                        <td><small class="text-muted">{{task.title}}</small></td>
                                                                        <td><small>{{task.assignedTo_name}}</small></td>
                                                                        <td><small>{{task.percent_done}}</small></td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            <div class="row">
                                                                <div class="col-12">
                                                                    <div class="bg-white text-center">
                                                                        <small><pagination-controls autoHide="true" (pageChange)="ip = $event" maxSize="10"></pagination-controls></small>
                                                                    </div>        
                                                                </div>
                                                            </div> 
                                                        </div>
                                                        <p *ngIf="sel2.incidentTaskCount == 0">*No Recorded Task for this Incident.</p>   
                                                    </div>           
        
                                                </div>
                                        </div>
                                    </div>
        
                                </div> <!-- END ROW -->
                                <div class="row">
                                    <div class="col-md-12">
                                            <small><i>Click on a row to select. Details on a selected row are shown on the right window.</i></small>
                                    </div>
                                </div>
        
        
                            </div>
                    <div class="tab-pane" id="tb">
                        <div class="row pt-0">
                            <div class="col-md-12">
                                <button type="button" class="btn btn-secondary btn-sm mb-1 mr-1" aria-expanded="false"
                                ngbTooltip="Add New Traffic Ticket" (click)="openTicketModal(null)" data-backdrop="static" data-keyboard="false">
                                    <span class="sr-only">Add</span>
                                    <i class="fa fa-lg fa-plus"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Add</span>
                                </button>
                                
                                
                                <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="print('ticket-print-section')" placement="bottom" [disabled]="ticketCount < 1"
                                    ngbTooltip="Print List">
                                    <i class="fa fa-lg fa-print"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Print</span>
                                </button>

                                <div class="btn-group mr-1">
                                    <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  [disabled]="ticketCount < 1"
                                        placement="bottom" ngbTooltip="Export List">
                                        <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Export</span>
                                    </button>
                                    <div class="dropdown-menu fs-12">
                                        <a (click)="trafficTicket_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                                        <a (click)="trafficTicket_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
                                        <a (click)="trafficTicket_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                                    </div>
                                </div>
                    

                                <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1"
                                    (click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
                                   <i class="fa fa-lg fa-filter"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Filter</span>
                    
                                </button>
                     
                                <div class="btn-group mb-1">
                                    <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                        placement="bottom" ngbTooltip="Show/Hide Columns">
                                        <span class="sr-only">Toggle Dropdown</span>
                                        <i class="fa fa-lg fa-check-square-o"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Columns</span>
                                    </button>
                                    <div class="dropdown-menu fs-12" style="width: 150px;">
                                        <div class="col-md-12 mb-3 fs-12">
                                            <input type="checkbox" [(ngModel)]="showTicketDate">&nbsp;Date<br />
                                            <input type="checkbox" [(ngModel)]="showTicketTime">&nbsp;Time<br />
                                            <input type="checkbox" [(ngModel)]="showTicketDriver">&nbsp;Driver<br />
                                            <input type="checkbox" [(ngModel)]="showTicketStatus">&nbsp;Status<br />
                                            <input type="checkbox" [(ngModel)]="showTicketFile">&nbsp;File<br />
                                    </div>
                                    </div>
                                </div>

                                <span *ngIf="myDropDown1=='range'" class="pull-right" >&nbsp;
                                    <input type="text"   width="120" class="mb-1" class="dateRangeInput" matInput
                                    ngxDaterangepickerMd
                                    [locale]="locale"
                                    startKey="start"
                                    endKey="end"
                                    [showWeekNumbers]="true"
                                    [showDropdowns]="true"
                                    [(ngModel)]="ticketDateRange"
                                    (ngModelChange)="processTicketDateRange()"
                                    name="daterange" 
                                    [autoApply]="true"
                                    opens="left"
                                    drops="down"
                                    [maxDate]="maxDate"
                                    />
                                </span>

                                <select [(ngModel)]="myDropDown1" (ngModelChange)="onChangeofOptions1($event)" class="dateFilter  btn btn-sm  btn-secondary mb-1 pull-right">
                                            <option value="today">Today</option>
                                            <option value="week">This Week</option>
                                            <option value="month">This Month</option>
                                            <option value="years">This Year</option>
                                            <option value="7">Last 7 days</option>
                                            <option value="14">Last 14 days</option>
                                            <option value="30">Last 30 days</option>
                                            <option value="90">Last 90 days</option>
                                            <option value="range">Custom date range</option>
                                    </select>
                            </div>
                        </div>
                        <br *ngIf="showFilters" />
                        <div class="row pt-0">
                            <div class="col-md-12">
                                <div widget class="card border-0 box-shadow" *ngIf="showFilters">
                                    <div class="card-header border-0 text-muted">
                                        <h5 class="mb-0">Search Traffic Tickets:</h5>
                                        <div class="widget-controls"> 
                                            <a data-widgster="close"class="transition" (click)="toggleFilters()"><i class="fa fa-times"></i></a>
                                        </div>  
                                    </div>
                                    <div class="card-body card-header pt-0 widget-body">
                                        <div class="row pt-0">
                                            <div class="form-group col-md-6" *ngIf="!driver_id">
                                                <label>Driver:</label> 
                                                <select placeholder="Select" [(ngModel)]="filterTicketDriver" (change)="updateFilter(prefixTicket)"> 
                                                    <option selected disabled>Select..</option>
                                                    <option *ngFor="let dr of drivers" value="{{dr.id}}">{{dr.full_name}}</option>
                                                </select>
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label>Violation:</label> 
                                                <input type="text" [(ngModel)]="filterTicketViolation" (keyup)="updateFilter(prefixTicket)"> 
                                            </div>
                                        </div>
                                        <div class="row" *ngIf="!isFilterEmpty || ticketDateRange !=''">
                                            <div class="col-md-12">
                                                <button  type="button" class="btn btn-success btn-sm mb-1" (click)="resetFilters(prefixTicket)">
                                                        <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-lg fa-filter"></i></span>
                                                        <span> Reset Filters</span>
                                                </button> &nbsp;
                                            </div>
                                        </div>                                  
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br *ngIf="showFilters" />
                        <ngx-loading [show]="loading_indicator1"></ngx-loading>
                        <div class="row pt-0 pl-0" *ngIf="!loading_indicator1">
                            <div class="col-md-8 pt-0">
                                <div class="card-body ml-0 pl-0 ml-0 widget-body">
                                    <span>
                                        Items: <span style="color: rgb(23, 98, 141);">{{ (totalTicket !== null) ?   (totalTicket) : "0"}}</span>   |  
                                        Average Amount: <span style="color: rgb(23, 98, 141);">{{ (averageTicketAmount  && averageTicketAmount !== null) ?   '$' + (averageTicketAmount | number:'1.2-2') : "0.00"}}</span> |
                                        Total Amount: <span style="color: rgb(23, 98, 141);">{{ (totalTicketAmount  && totalTicketAmount !== null) ?   '$' + (totalTicketAmount | number:'1.2-2') : "0.00"}}</span>
                                    </span>
                                    <span *ngIf="rows.length > 0" class="card-body">
                                        <span class="badge badge-pill badge-completed pull-right">Paid</span>
                                        <span class="badge badge-pill badge-pending pull-right">Pending</span>
                                    </span><br />
                                    <ngx-datatable 
                                        [loadingIndicator]="loading_indicator1"
                                        class="material"
                                        [rows]="rows"
                                        [columnMode]="'force'"
                                        [columns]="ticket_columns"
                                        [footerHeight]="40"
                                        [rowHeight]="'auto'"
                                        [limit]="20"
                                        [selected]="selected"
                                        [selectionType]="'single'"
                                        (activate)="onActivate($event)"
                                        (select)='onSelect($event)'
                                        [scrollbarH]="true">

                                        <ngx-datatable-column prop="id" name="Operations" headerClass="header" [width]="130" [cellClass]="getCellClass"> 
                                            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                                                <div align="left" style="padding-right:20px">  
                                                    <a title="Edit" (click)="openTicketModal(row)"><i class="fa fa-lg fa-edit"></i></a>&nbsp;
                                                    <a title="Delete" (click)="openDeleteTicketModal(row)"><i class="fa fa-lg fa-trash"></i></a>&nbsp;
                                                    <a title="Create New Task" (click)="openPromptModalTask(modalTaskForm, null, row.id, prefixTicket)"><i class="fa fa-lg fa-plus-square-o"></i></a>&nbsp;
                                                    <a *ngIf="row.ticketTaskCount > 0" title="Mark as Completed" (click)="openMarkCompleteModal(modalMarkCompleted, prefixTicket)"><i class="fa fa-lg fa-check-square-o"></i></a>

                                                </div>
                                            </ng-template>     
                                        </ngx-datatable-column>

                                        <ngx-datatable-column name="Date" prop="date"  headerClass="header" [width]="120" *ngIf="showTicketDate" [cellClass]="getCellClass">
                                            <ng-template let-value="value" ngx-datatable-cell-template>
                                             
                                                {{ (formatDate(value) !== null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                                            </ng-template>
                                        </ngx-datatable-column>
                                        
                                        <ngx-datatable-column name="Time" prop="time"  headerClass="header" [width]="120" *ngIf="showTicketTime" [cellClass]="getCellClass">
                                            <ng-template let-value="value" ngx-datatable-cell-template>
                                                {{ (value !== null) ? ('1999-01-01 ' + value | date: 'h:mm a') : "No Record"  }}
                                            </ng-template>                        
                                        </ngx-datatable-column>

                                        <ngx-datatable-column name="Driver" prop="driver"  headerClass="header" [width]="120" *ngIf="showTicketDriver" [cellClass]="getCellClass"></ngx-datatable-column>

                                        <ngx-datatable-column name="Status" prop="status"  headerClass="header" [width]="120" *ngIf="showTicketStatus" [cellClass]="getCellClass"></ngx-datatable-column>

                                        <ngx-datatable-column name="File" prop="file"  headerClass="header" [width]="200" *ngIf="showTicketFile" [cellClass]="getCellClass">
                                            <ng-template let-value="value" ngx-datatable-cell-template>
                                                <a href="{{fileStoragePath}}/tickets/{{value}}" target="_new">{{value}}</a>
                                            </ng-template>
                                        </ngx-datatable-column>
                                    </ngx-datatable>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div widget class="card border-0 box-shadow selected-column">
                                    <div class="card-header transparent border-0 text-muted">
                                        <h5 class="mb-0">Details:</h5>
                                        <div class="widget-controls"> 
                                        </div>        
                                    </div>
                                    <div class="card-body pt-0 widget-body">
                                            <ul>                                                    
                                                <div *ngFor='let sel of selected'>
                                                    <label class="titleHeader"><b>{{sel["driver"]}}</b></label>&nbsp;&nbsp;
                                                    <a *ngIf="sel['file']!==null && sel['file']!==''" href="{{fileStoragePath}}/tickets/{{sel['file']}}" target="_new" title="View File">
                                                        <i class="fa fa-file"></i>
                                                    </a><br/>
                                                    
                                                    <tr>
                                                        <td><b>Datetime:</b></td>
                                                        <td class="col-md-8">{{sel.date}} - {{sel.time}}</td>
                                                    </tr>

                                                    <tr>
                                                        <td><b>Location:</b></td>
                                                        <td class="col-md-8">{{sel.location}}</td>
                                                    </tr>
                                                    
                                                    <tr>
                                                        <td><b>Violation:</b></td>
                                                        <td class="col-md-8">{{sel.violation}}</td>
                                                    </tr>

                                                    <tr>
                                                        <td><b>Rego:</b></td>
                                                        <td class="col-md-8">{{sel.rego}}</td>
                                                    </tr>
                                                    
                                                    <tr>
                                                        <td><b>Status:</b></td>
                                                        <td class="col-md-8">
                                                            <span *ngIf="sel.status_id == 2" class="badge badge-pill badge-completed">Resolved</span>
                                                            <span *ngIf="sel.status_id == 1" class="badge badge-pill badge-pending">Pending</span><br/>
                                                        </td>
                                                    </tr>
                                                 
                                                    <tr>
                                                        <td><b>Cost:</b></td>
                                                        <td class="col-md-8">${{ sel.cost | number:'3.2-5'}}</td>
                                                    </tr>
                                                    
                                                    <tr>
                                                        <td><b>Demerits:</b></td>
                                                        <td class="col-md-8">{{sel.demerits}}</td>
                                                    </tr>

                                                    <tr>
                                                        <td><b>Note:</b></td>
                                                        <td class="col-md-8">{{sel.note}}</td>
                                                    </tr>

                                                    <br/>
                                                
                                                    <button type="button" class="btn btn-sm btn-secondary mb-1" (click)="openTicketModal(sel)">
                                                        <span class="badge badge-pill badge-white text-primary ml-1"></span>
                                                        Edit
                                                    </button>&nbsp;
                                                    <button type="button" class="btn btn-sm btn-danger mb-1" (click)="openDeleteTicketModal(sel)">
                                                        <span class="badge badge-pill badge-white text-primary ml-1"></span>
                                                        Delete
                                                    </button>
                                                </div>
                                                <div *ngIf="!selected.length" class="text-center"> 
                                                    <p> Select an item to display details. </p>
                                                </div>
                                            </ul>         
                                    </div>
                                </div>
                                <br />
                                <div widget class="card border-0 box-shadow selected-column">
                                        <div class="card-header transparent border-0 text-muted">
                                            <h5 class="mb-0">Traffic Ticket Tasks:</h5>
                                            <div class="widget-controls">
                                            </div>        
                                        </div>
                                        <div class="card-body pt-0 widget-body">
                                            <div *ngFor='let sel of selected'>
                                                
                                                <div *ngIf ="sel.ticketTaskCount > 0">
                                                    <button type="button" class="btn btn-sm btn-secondary mb-1" (click)="openMarkCompleteModal(modalMarkCompleted, prefixTicket)">
                                                    <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-check-square-o"></i></span>
                                                    Mark as Completed
                                                    </button>
                                                    <br />
                                                    <table class="table table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th><small><strong>Title</strong></small></th>
                                                                <th><small><strong>Assigned To</strong></small></th>
                                                                <th><small><strong>% Done</strong></small></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr *ngFor="let task of tasksByTrafficTicketId | paginate: { itemsPerPage: 5, currentPage: tp }">
                                                                <td><small><i class="fa fa-pencil" title="Edit Task" (click)="openPromptModalTask(modalTaskForm, task, sel.id, prefixTicket)"></i> <i *ngIf="task.status_name !== 'Completed' && task.status_name !== 'Cancelled'" class="fa fa-check" title="Mark Task Completed" (click)="openPromptModal(modalMarkTaskCompleted,task, prefixTicket)"></i>
                                                                    <i class="fa fa-trash" title="Delete Task" (click)="openPromptModal(modalDeleteTask,task, prefixTicket)"></i></small>
                                                                </td>
                                                                <td><small class="text-muted">{{task.title}}</small></td>
                                                                <td><small>{{task.assignedTo_name}}</small></td>
                                                                <td><small>{{task.percent_done}}</small></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <div class="bg-white text-center">
                                                                <small><pagination-controls autoHide="true" (pageChange)="tp = $event" maxSize="10"></pagination-controls></small>
                                                            </div>        
                                                        </div>
                                                    </div> 
                                                </div>
                                                <p *ngIf="sel.ticketTaskCount == 0">*No Recorded Task for this Traffic Ticket.</p>   
                                            </div>           

                                        </div>
                                </div>
                            </div>
                        </div> <!-- END ROW -->
                        <div class="row">
                            <div class="col-md-12">
                                    <small><i>Click on a row to select. Details on a selected row are shown on the right window.</i></small>
                            </div>
                        </div>

                    </div>
                    
                    
                </div>                   
            </div>
        </div>
        

      </div>
</div>



<!-- START OF ADD TICKET FORM -->
<ng-template #modalTicket let-close="close">
    <div class="modal-header">
            <h5 class="modal-title" *ngIf="isEditMode==false">Add New Traffic</h5>
            <h5 class="modal-title" *ngIf="isEditMode==true">Edit Traffic Ticket</h5>
                <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="ticketForm" novalidate (ngSubmit)="onSubmitTicket(ticketForm.value)">
        <div class="modal-body">
            <div class="row pt-0">
                <div class="form-group col-md-4" >
                    <h6>Date<span class="text-danger">*</span> :</h6>
                    <input formControlName="date" class="form-control form-control-sm" type="date" max="{{dateNow|date:'yyyy-MM-dd'}}" required>
                    <div *ngIf="ticketForm.controls.date.touched">
                        <div *ngIf="ticketForm.controls.date.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div> 
                </div>
                
                <div class="form-group col-md-4" >
                    <h6>Location<span class="text-danger">*</span> :</h6>
                    <input formControlName="location" class="form-control form-control-sm" type="text" required>
                    <div *ngIf="ticketForm.controls.location.touched">
                        <div *ngIf="ticketForm.controls.location.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div> 
                </div>
                <div class="form-group col-md-4" >
                    <h6>Status<span class="text-danger">*</span> :</h6>
                    <select class="form-control form-control-sm" placeholder="Select" formControlName="status_id" required> 
                        <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                        <option *ngFor="let status of ticket_statuses" value="{{status.id}}">{{status.name}}</option>
                    </select>
                    <div *ngIf="ticketForm.controls.status_id.touched">
                        <div *ngIf="ticketForm.controls.status_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div> 
                </div>
     
            </div>
            <div class="row pt-0">
                <div class="col-md-4">
                    <h6>Driver<span class="text-danger">*</span> :</h6>
                    <select [id]="driver_id" class="form-control form-control-sm" placeholder="Select" formControlName="driver_no" required> 
                        <option disabled selected *ngIf="isEditMode==false">Select..</option>
                        <option *ngFor="let dr of drivers" value="{{dr.id}}">{{dr.full_name}}</option>
                    </select>
                    <div *ngIf="ticketForm.controls.driver_no.touched">
                        <div *ngIf="ticketForm.controls.driver_no.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div> 
                </div>
                <div class="col-md-4">
                    <h6>Fleet<span class="text-danger">*</span> :</h6>
                    <select class="form-control form-control-sm" placeholder="Select" formControlName="fleet_id" required> 
                        <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                        <option *ngFor="let fl of fleet" value="{{fl.id}}">{{fl.rego}}</option>
                    </select>
                    <div *ngIf="ticketForm.controls.fleet_id.touched">
                        <div *ngIf="ticketForm.controls.fleet_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-4" >
                    <h6>Cost<span class="text-danger">*</span> :</h6>
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                            <div class="input-group-text">$</div>
                        </div>
                    <input formControlName="cost" class="form-control form-control-sm" type="text" required> 
                    </div>
                    <div *ngIf="ticketForm.controls.cost.touched">
                        <div *ngIf="ticketForm.controls.cost.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                        <div *ngIf="ticketForm.controls.cost.errors?.pattern && !isCost() ">
                            <small class="text-danger">Cost must have a valid currency value.</small>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="row pt-0">
                <div class="form-group col-md-4" >
                    <h6>Receipt #<span class="text-danger">*</span>:</h6>
                    <input formControlName="receipt_no" class="form-control form-control-sm" type="text" required>
                    <div *ngIf="ticketForm.controls.receipt_no.touched">
                        <div *ngIf="ticketForm.controls.receipt_no.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                        <div *ngIf="ticketForm.controls.receipt_no.errors?.pattern">
                            <small class="text-danger">This field requires numeric values only.</small>
                        </div>
                    </div> 
                </div>
                <div class="form-group col-md-4" >
                    <h6>Violation<span class="text-danger">*</span> :</h6>
                    <input formControlName="violation" class="form-control form-control-sm" type="text" required> 
                    <div *ngIf="ticketForm.controls.violation.touched">
                        <div *ngIf="ticketForm.controls.violation.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div> 
                </div>
                <div class="form-group col-md-4" >
                    <h6>Demerits<span class="text-danger">*</span> :</h6>
                    <input formControlName="demerits" class="form-control form-control-sm" type="number" required> 
                    <div *ngIf="ticketForm.controls.demerits.touched">
                        <div *ngIf="ticketForm.controls.demerits.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row pt-0">
                <div class="col-lg-4 col-md-4 mb-4"> 
                    <h6>Time<span class="text-danger">*</span> :</h6>
                    <ngb-timepicker formControlName="time_string" [meridian]="true" required></ngb-timepicker>
                    <div *ngIf="ticketForm.controls.time_string.touched">
                        <div *ngIf="ticketForm.controls.time_string.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>  
                
                <div class="form-group col-md-4" >
                    <label class="form-control-label">Note:</label>
                    <textarea class="form-control form-control-sm" formControlName="note" rows="4" cols="50"></textarea>
                </div>
            </div>
            <div class="row pt-0">
                <div class="col-md-4">
                    <div class="form-group" *ngIf ="(fileExists==true)">
                        <label class="form-control-label">File:</label><br/>
                        <label>{{ticket?.file}}</label> <button class="btn btn-sm btn-primary" type="button" (click)="removeFile(prefixTicket)">Remove File</button>
                    </div>
                    <div class="form-group" *ngIf ="(fileExists==false)">
                        <label class="text-gray">File:</label>
                        <app-image-uploader (passImage)="getFile($event, prefixTicket)"></app-image-uploader>
                    </div>
                    <small><i>*Note: Allowed files are *.pdf, image files (*png,*.jpg,*.gif).</i></small>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <small  class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button *ngIf="isEditMode==false" type="submit" class="btn btn-sm btn-success" [disabled]="!ticketForm.valid || spinner == true">Save</button>
            <button *ngIf="isEditMode==true" type="submit" class="btn btn-sm btn-success" [disabled]="!ticketForm.valid || spinner == true">Save Changes</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="close()" >Cancel</button>
        </div>
    </form>
</ng-template>
<!-- END OF MODAL TICKET FORM -->


<!-- START OF INCIDENT FORM -->
<ng-template #modalIncident let-close="close">
    <div class="modal-header">
            <h5 class="modal-title" *ngIf="isEditMode==false">Add New Incident</h5>
            <h5 class="modal-title" *ngIf="isEditMode==true">Edit Incident</h5>
                <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="incidentForm" novalidate (ngSubmit)="onSubmitIncident(incidentForm.value)">
        <div class="modal-body">
            <div class="row pt-0">
                <div class="form-group col-md-4" >
                    <h6>Date<span class="text-danger">*</span></h6>
                    <input formControlName="date_added" class="form-control form-control-sm" type="date" max="{{dateNow|date:'yyyy-MM-dd'}}" required>
                    <div *ngIf="incidentForm.controls.date_added.touched">
                        <div *ngIf="incidentForm.controls.date_added.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>  
                </div>
                <div class="form-group col-md-4" >
                    <h6>Description<span class="text-danger">*</span>:</h6>
                    <input formControlName="description" class="form-control form-control-sm" type="text" required>
                    <div *ngIf="incidentForm.controls.description.touched">
                        <div *ngIf="incidentForm.controls.description.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div> 
                </div>
                <div class="col-md-4">
                    <h6>Status<span class="text-danger">*</span>:</h6>
                    <select [id]="status_id" class="form-control form-control-sm" placeholder="Select" formControlName="status_id" required> 
                        <option disabled selected *ngIf="isEditMode==false">Select..</option>
                        <option *ngFor="let st of incident_statuses" value="{{st.id}}">{{st.name}}</option>
                    </select>
                    <div *ngIf="incidentForm.controls.status_id.touched">
                        <div *ngIf="incidentForm.controls.status_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
            </div>
        
            <div class="row pt-0">
                <div class="col-md-4">
                    <h6>Type<span class="text-danger">*</span>:</h6>
                    <select class="form-control form-control-sm" placeholder="Select" formControlName="type_id" required> 
                        <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                        <option *ngFor="let ti of incident_types" value="{{ti.id}}">{{ti.name}}</option>
                    </select>
                    <div *ngIf="incidentForm.controls.type_id.touched">
                        <div *ngIf="incidentForm.controls.type_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <h6>Driver<span class="text-danger">*</span>:</h6>
                    <select [id]="driver_id" class="form-control form-control-sm" placeholder="Select" formControlName="driver_id" required> 
                        <option disabled selected *ngIf="isEditMode==false">Select..</option>
                        <option *ngFor="let dr of drivers" value="{{dr.id}}">{{dr.full_name}}</option>
                    </select>
                    <div *ngIf="incidentForm.controls.driver_id.touched">
                        <div *ngIf="incidentForm.controls.driver_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <h6>Fleet<span class="text-danger">*</span>:</h6>
                    <select class="form-control form-control-sm" placeholder="Select" formControlName="fleet_id" required> 
                        <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                        <option *ngFor="let fl of fleet" value="{{fl.id}}">{{fl.rego}}</option>
                    </select>
                    <div *ngIf="incidentForm.controls.fleet_id.touched">
                        <div *ngIf="incidentForm.controls.fleet_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
       
            </div> 
            <div class="row pt-0">
                <div class="form-group col-md-4" >
                    <h6>Location<span class="text-danger">*</span>:</h6>
                    <input formControlName="location" class="form-control form-control-sm" type="text"> 
                    <div *ngIf="incidentForm.controls.location.touched">
                        <div *ngIf="incidentForm.controls.location.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                
                <div class="form-group col-md-4" >
                    <h6>Witness<span class="text-danger">*</span>:</h6>
                    <input formControlName="witness" class="form-control form-control-sm" type="text"> 
                    <div *ngIf="incidentForm.controls.witness.touched">
                        <div *ngIf="incidentForm.controls.witness.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>

                <div class="form-group col-md-4" >
                    <label class="form-control-label">Notification:</label>
                    <input formControlName="notification" class="form-control form-control-sm" type="text"> 
                </div>
            </div>
            <div class="row pt-0">
                <div class="col-lg-4 col-md-4 mb-4"> 
                    <h6>Time<span class="text-danger">*</span></h6>
                    <ngb-timepicker formControlName="time_string" [meridian]="true" required></ngb-timepicker>
                    <div *ngIf="incidentForm.controls.time_string.touched">
                        <div *ngIf="incidentForm.controls.time_string.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>     
                </div>   
                
                <div class="col-md-4">
                    <h6>Rating<span class="text-danger">*</span>:</h6>
                    <select class="form-control form-control-sm" placeholder="Select" formControlName="rating_id" required> 
                        <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                        <option *ngFor="let rt of ratings" value="{{rt.id}}">{{rt.name}}</option>
                    </select>
                    <div *ngIf="incidentForm.controls.rating_id.touched">
                        <div *ngIf="incidentForm.controls.rating_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div> 
                </div>
            </div>
            <div class="row pt-0">
                <div class="col-md-4">
                    <div class="form-group" *ngIf ="(fileExists==true)">
                        <label class="form-control-label">File:</label><br/>
                        <label>{{incident?.filename}}</label> <button class="btn btn-sm btn-primary" type="button" (click)="removeFile(prefixIncident)">Remove File</button>
                    </div>
                    <div class="form-group" *ngIf ="(fileExists==false)">
                        <label class="text-gray">File:</label>
                        <app-image-uploader (passImage)="getFile($event, prefixIncident)"></app-image-uploader>
                    </div>
                    <small><i>*Note: Allowed files are *.pdf, image files (*png,*.jpg,*.gif).</i></small>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button *ngIf="isEditMode==false" type="submit" class="btn btn-sm btn-success" [disabled]="!incidentForm.valid || spinner == true">Save</button>
            <button *ngIf="isEditMode==true" type="submit" class="btn btn-sm btn-success" [disabled]="!incidentForm.valid || spinner == true">Save Changes</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="close()" >Cancel</button>
        </div>

    </form>
</ng-template>
<!-- END OF MODAL INCIDENT FORM -->
<!-- START OF INCIDENT MOBILE FORM -->
<ng-template #modalIncidentMobile let-close="close">
    <div class="modal-header">
            <h5 class="modal-title" *ngIf="isEditMode==false">Add New Incident</h5>
            <h5 class="modal-title" *ngIf="isEditMode==true">Edit Incident</h5>
                <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="incidentFormMobile" novalidate (ngSubmit)="onSubmitIncidentMobile(incidentFormMobile.value)">
        <div class="modal-body">
            <div class="row pt-0">
                <div class="form-group col-md-4" >
                    <h6>Date<span class="text-danger">*</span></h6>
                    <input formControlName="date_added" class="form-control form-control-sm" type="date" max="{{dateNow|date:'yyyy-MM-dd'}}" required>
                    <div *ngIf="incidentFormMobile.controls.date_added.touched">
                        <div *ngIf="incidentFormMobile.controls.date_added.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>  
                </div>

                <div class="form-group col-md-4" >
                    <h6>Description<span class="text-danger">*</span>:</h6>
                    <input formControlName="incident" class="form-control form-control-sm" type="text" required>
                    <div *ngIf="incidentFormMobile.controls.incident.touched">
                        <div *ngIf="incidentFormMobile.controls.incident.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div> 
                </div>
            </div>
        
            <div class="row pt-0">
                <div class="col-md-4">
                    <h6>Type<span class="text-danger">*</span>:</h6>
                    <select class="form-control form-control-sm" placeholder="Select" formControlName="type_opt" required> 
                        <option disabled selected *ngIf="isEditMode==false">Select..</option>
                        <option *ngFor="let ty of type_opt" value="{{ty.name}}">{{ty.desc}}</option>
                    </select>
                </div>
                <div class="col-md-4">
                    <h6>Driver<span class="text-danger">*</span>:</h6>
                    <select [id]="driver_id" class="form-control form-control-sm" placeholder="Select" formControlName="driver_id" required> 
                        <option disabled selected *ngIf="isEditMode==false">Select..</option>
                        <option *ngFor="let dr of drivers" value="{{dr.id}}">{{dr.full_name}}</option>
                    </select>
                    <div *ngIf="incidentFormMobile.controls.driver_id.touched">
                        <div *ngIf="incidentFormMobile.controls.driver_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <h6>Fleet<span class="text-danger">*</span>:</h6>
                    <select class="form-control form-control-sm" placeholder="Select" formControlName="fleet_id" required> 
                        <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                        <option *ngFor="let fl of fleet" value="{{fl.id}}">{{fl.rego}}</option>
                    </select>
                    <div *ngIf="incidentFormMobile.controls.fleet_id.touched">
                        <div *ngIf="incidentFormMobile.controls.fleet_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
       
            </div> 
            <div class="row pt-0">
                <div class="form-group col-md-4" >
                    <h6>Location<span class="text-danger">*</span>:</h6>
                    <input formControlName="location" class="form-control form-control-sm" type="text"> 
                    <div *ngIf="incidentFormMobile.controls.location.touched">
                        <div *ngIf="incidentFormMobile.controls.location.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                
                <div class="form-group col-md-4" >
                    <label class="form-control-label">Witness:<span class="text-danger">*</span></label>
                    <input formControlName="witness" class="form-control form-control-sm" type="text"> 
                </div>
                <div class="form-group col-md-4" >
                    <label class="form-control-label">Notification:<span class="text-danger">*</span></label>
                    <input formControlName="notification" class="form-control form-control-sm" type="text"> 
                </div>
            </div>
            <div class="row pt-0">
                <div class="col-lg-4 col-md-4 mb-4"> 
                    <h6>Time<span class="text-danger">*</span></h6>
                    <ngb-timepicker formControlName="time_added" [meridian]="true" required></ngb-timepicker>
                    <div *ngIf="incidentFormMobile.controls.time_added.touched">
                        <div *ngIf="incidentFormMobile.controls.time_added.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>     
                </div>

                <div class="col-lg-8 col-md-8 mb-4"> 
                    <app-multiple-image-uploader (passImages)="getImages($event)"></app-multiple-image-uploader>
                </div>
            </div>
            <div class="solid">
            <signature-pad #signaturePad [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete1(signaturePad)"></signature-pad>
            <label color="dark" class="signature-style">
                <strong style="font-size: 15px;">Signature</strong>
            </label>
            <button type="button" class="btn btn-lg btn-secondary btn-block clear" (click)="signaturePad.clear();signatureImage = null;">Clear</button>
            </div>
        </div>
        <div class="modal-footer">
            <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button *ngIf="isEditMode==false" type="submit" class="btn btn-sm btn-success" [disabled]="!(incidentFormMobile.valid && signatureImage) || spinner == true" >Save</button>
            <button *ngIf="isEditMode==true" type="submit" class="btn btn-sm btn-success" [disabled]="!(incidentFormMobile.valid && signatureImage) || spinner == true">Save Changes</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="close()" >Cancel</button>
        </div>

    </form>
</ng-template>
<!-- END OF MODAL INCIDENT MOBILE FORM -->


<!-- START OF DELETE TICKET FORM -->
<ng-template #modalDeleteTicket let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Delete Ticket</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
               Do you really want to delete this ticket?
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger"  (click)="deleteTicket(ticket)"  [disabled]="spinner == true">Delete</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL DELETE TICKET FORM -->


<!-- START OF DELETE INCIDENT FORM -->
<ng-template #modalDeleteIncident let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Delete Incident</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
               Do you really want to delete the current incident?
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger"  (click)="deleteIncident(incident)"  [disabled]="spinner == true">Delete</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL DELETE INCIDENT FORM -->

<!-- START INCIDENT PRINT-->
<div id="incident-print-section" style="display:none">
    <table style="width:100%">
        <tr>
            <th align="left" *ngIf="showIncidentDate">DATE</th>
            <th align="left" *ngIf="showIncidentTime">TIME</th>
          <!--  <th align="left">DESCRIPTION</th>
            <th align="left">LOCATION</th> -->
            <th align="left" *ngIf="showIncidentDriver">DRIVER</th>
            <th align="left" *ngIf="showIncidentStatus">STATUS</th>
            <th align="left" *ngIf="showIncidentFile">FILE</th>
         </tr>
        <tr *ngFor="let row of incident_rows">
            <td *ngIf="showIncidentDate">{{ (formatDate(row.date_added) !== null && row.date_added != '0000-00-00') ? (formatDate(row.date_added) | date: 'dd MMM yyyy') : "No Date"  }}  </td> 
            <td *ngIf="showIncidentTime"> {{ (row.time_added !== null) ? ('1999-01-01 ' + row.time_added | date: 'h:mm a') : "No Record"  }}</td>
            <td *ngIf="showIncidentDriver">{{row.driver}}</td>
            <td *ngIf="showIncidentStatus">{{row.status}}</td>
            <td *ngIf="showIncidentFile"><div class="justify-content-left">{{row.filename}}</div></td>
        </tr>
    </table>
</div>
<!-- END PRINT -->

<!-- START TICKET PRINT-->
<div id="ticket-print-section" style="display:none">
    <table style="width:100%">
        <tr>
            <th align="left" *ngIf="showTicketDate">DATE</th>
            <th align="left" *ngIf="showTicketTime">TIME</th>
            <th align="left" *ngIf="showTicketDriver">DRIVER</th>
            <th align="left" *ngIf="showTicketStatus">STATUS</th>
            <th align="left" *ngIf="showTicketFile">FILE</th>
        </tr>
        <tr *ngFor="let row of rows">
            <td *ngIf="showTicketDate">{{ (formatDate(row.date) !== null && row.date != '0000-00-00' ) ? (formatDate(row.date) | date: 'dd MMM yyyy') : "No Date"  }}</td> 
            <td *ngIf="showTicketTime"> {{ (row.time !== null) ? ('1999-01-01 ' + row.time | date: 'h:mm a') : "No Record"  }}</td>
            <td *ngIf="showTicketDriver">{{row.driver}}</td>
            <td *ngIf="showTicketStatus">{{row.status}}</td>
            <td *ngIf="showTicketFile">{{row.file}}</td>
        </tr>
    </table>
</div>
<!-- END PRINT -->

<!--- START OF MARK ALL TASK COMPLETED MODAL -->
<ng-template #modalMarkCompleted let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Mark Tasks Completed</h5>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">

            <div class="col-md-12">
                {{modalCaller}} Description: <b *ngIf="modalCaller=='Traffic Ticket'"><i>{{selected[0].violation}}</i></b><b *ngIf="modalCaller=='Incident'"><i>{{selected2[0].description}}</i></b> <br/>
                Driver: <b *ngIf="modalCaller=='Traffic Ticket'"><i>{{selected[0].driver}}</i></b><b *ngIf="modalCaller=='Incident'"><i>{{selected2[0].driver}}</i></b> <br/> <br/>
                <p>Are you sure you want to mark all task for this {{modalCaller}} completed?</p>
            </div>

      
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button *ngIf="modalCaller=='Traffic Ticket'" type="button" class="btn btn-sm btn-success" (click)="markCompleted(selected[0].id, prefixTicket)"  [disabled]="spinner == true">
            
            Yes</button>
        <button *ngIf="modalCaller=='Incident'" type="button" class="btn btn-sm btn-success" (click)="markCompleted(selected2[0].id, prefixIncident)"  [disabled]="spinner == true">
            
            Yes</button>
        
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">No</button>
    </div>
</ng-template>
<!-- END OF MARK ALL TASK COMPLETED MODAL -->


<!--- START OF MARK TASK COMPLETED MODAL -->
<ng-template #modalMarkTaskCompleted let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Mark Task Completed</h5>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
                Task Title: <b><i>{{task.title}}</i></b><br/> <br/>
                <p>Are you sure you want to mark this task as completed?</p>
            </div>
      
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-success" (click)="markTaskCompleted(task.id, caller)"  [disabled]="spinner == true">
            
            Yes</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">No</button>
    </div>
</ng-template>
<!-- END OF MARK TASK COMPLETED MODAL -->


<!-- START OF DELETE TASK FORM -->
<ng-template #modalDeleteTask let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Delete Task</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
               Do you really want to delete <b><i>{{task.title}}</i></b>?
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger"  (click)="deleteTask(task.id)"  [disabled]="spinner == true">Delete</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL DELETE TASK FORM -->

<!-- START OF TASK MODAL FORM -->
<ng-template #modalTaskForm let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">{{action}} Task</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

                <app-addupdatetask *ngIf="modalCaller=='Traffic Ticket'" [task]="task ? task : null" [caller]="prefixTicket" [objectId]="trafficTicketId" (closeModal)="closeModalTask(prefixTicket)"></app-addupdatetask>
                <app-addupdatetask *ngIf="modalCaller=='Incident'" [task]="task ? task : null" [caller]="prefixIncident" [objectId]="incidentId" (closeModal)="closeModalTask(prefixIncident)"></app-addupdatetask>

</ng-template>
<!-- END OF TASK MODAL FORM -->

